import { IPagination } from 'app/types/common';

export interface ISubscriptionPaymentsState {
  readonly subscriptionPaymentsById?: any;
  readonly subscriptionPaymentIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectSubscriptionPaymentLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddSubscriptionPayment?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly subscriptionPaymentIds?: string[];
  readonly currentSubscriptionPaymentId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ISubscriptionPaymentsSelector extends ISubscriptionPaymentsState {
  readonly currentSubscriptionPayment?: any;
  readonly currentFormSubscriptionPayment?: any;
  readonly getSubscriptionPaymentsFilteredByTagInSelectFormat?: any;
  readonly SubscriptionPaymentsByIdInSelectFormat?: any;
}

export enum SubscriptionPaymentsActionTypes {
  UPDATE_SUBSCRIPTION_PAYMENT_REQUESTED = 'redux-app/subscription-payments/UPDATE_SUBSCRIPTION_PAYMENT_REQUESTED',
  UPDATE_SUBSCRIPTION_PAYMENT_PENDING = 'redux-app/subscription-payments/UPDATE_SUBSCRIPTION_PAYMENT_PENDING',
  UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS = 'redux-app/subscription-payments/UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS',
  UPDATE_SUBSCRIPTION_PAYMENT_FAIL = 'redux-app/subscription-payments/UPDATE_SUBSCRIPTION_PAYMENT_FAIL',
  GET_ALL_SUBSCRIPTION_PAYMENTS_REQUESTED = 'redux-app/subscription-payments/GET_ALL_SUBSCRIPTION_PAYMENTS_REQUESTED',
  GET_ALL_SUBSCRIPTION_PAYMENTS_PENDING = 'redux-app/subscription-payments/GET_ALL_SUBSCRIPTION_PAYMENTS_PENDING',
  GET_ALL_SUBSCRIPTION_PAYMENTS_SUCCESS = 'redux-app/subscription-payments/GET_ALL_SUBSCRIPTION_PAYMENTS_SUCCESS',
  GET_ALL_SUBSCRIPTION_PAYMENTS_FAIL = 'redux-app/subscription-payments/GET_ALL_SUBSCRIPTION_PAYMENTS_FAIL',
  GET_SUBSCRIPTION_PAYMENT_REQUESTED = 'redux-app/subscription-payments/GET_SUBSCRIPTION_PAYMENT_REQUESTED',
  GET_SUBSCRIPTION_PAYMENT_PENDING = 'redux-app/subscription-payments/GET_SUBSCRIPTION_PAYMENT_PENDING',
  GET_SUBSCRIPTION_PAYMENT_SUCCESS = 'redux-app/subscription-payments/GET_SUBSCRIPTION_PAYMENT_SUCCESS',
  GET_SUBSCRIPTION_PAYMENT_FAIL = 'redux-app/subscription-payments/GET_SUBSCRIPTION_PAYMENT_FAIL',
  SELECT_SUBSCRIPTION_PAYMENT_REQUESTED = 'redux-app/subscription-payments/SELECT_SUBSCRIPTION_PAYMENT_REQUESTED',
  CLEAR_SUBSCRIPTION_PAYMENTS = 'redux-app/subscription-payments/CLEAR_SUBSCRIPTION_PAYMENTS',
}

export interface ISubscriptionPayment {
  id: string;
  organisationName: string;
  competitionName: string;
  createdAt: string;
  updatedAt: string;
  dueAt: string;
  purchasedAt: string;
  collectedOtherAt: string;
  refundedAt: string;
  transferredAt: string;
  groupName: string;
  groupSectionName: string;
  groupSeasonName: string;
  subscriptionPaymentStatus: string;
  subscriptionPaymentDueStatus: string;
  subscriptionPaymentActiveStatus: string;
  subscriptionPaymentForfeitStatus?: string;
  subscriptionPaymentTransferStatus: string;
  subscriptionPaymentAdminStatus?: string;
  oppositionSubscriptionPaymentStatus: string;
  oppositionSubscriptionPaymentActiveStatus: string;
  oppositionSubscriptionPaymentForfeitStatus: string;
  oppositionSubscriptionPaymentTransferStatus?: string;
  oppositionSubscriptionPaymentAdminStatus?: string;
  fixtureMatchStatus?: string;
  status: string;
  paymentType: string;
  description: string;
  amount: number;
  netAmount: number;
  teammoFeeAmount: number;
  friendlyReference: string;
  organisationReference: string;
  secureReference: string;
  matchRoundName: string;
  matchAt: string;
  matchLocalDateAt: string;
  matchLocationName: string;
  matchHomeTeamName: string;
  matchHomeTeamId: string;
  matchHomeTeamUniqueKey: string;
  matchOppositionTeamName: string;
  matchOppositionTeamId: string;
  matchOppositionTeamUniqueKey: string;
  matchSectionName: string;
  matchSeasonName: string;
  organisation: string;
  competition: string;
  subscriptionPayment: string;
  fixtureMatch: string;
  group: string;
}

export default null;
